import { render, staticRenderFns } from "./Differ.vue?vue&type=template&id=16fcf516&scoped=true"
import script from "./Differ.vue?vue&type=script&lang=js"
export * from "./Differ.vue?vue&type=script&lang=js"
import style0 from "./Differ.vue?vue&type=style&index=0&id=16fcf516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fcf516",
  null
  
)

export default component.exports